import Sidebar from '@/components/Sidebar/SidebarView.vue';
import Navbar from '@/components/Navbar/NavbarView.vue';
import Swal from 'sweetalert2';
import { get_token } from "@/router";
import InactivityModal from '@/components/InactivityTracker/InactivityTracker.vue';


export default {
    components: {
        Sidebar,
        Navbar,
        InactivityModal
    },

    mounted() {
        this.fetch_forms();
        this.getProfileTypes();
    },

    data() {
        return ({
            forms: [],
            form_name: '',
            form_description: '',
            errors: {},
            profile_types: [],
            isSubmitting: false,
            isLoading: false,
            token_exists: false,
            selected_form_sections: [],
            selected_profiles : [],
            form_id:null,
            selected_business_tab:''
        });
    },
    watch:
    {'$route.params.form_id': function (newFormId) {
        this.save_form_id(newFormId);
    }},
    methods: {
        getToken() {
            return get_token();
        },
        toggleSidebar() {
            this.$refs.sidebar.$el.classList.toggle("close");
        },
        createForm() {
            if (!this.validateForm()) {
                return;
            }

            Swal.fire({
                title: 'Submitting...',
                text: 'Please wait while we process your request.',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            this.isSubmitting = true;

            const formData = new FormData();
            formData.append('form_name', this.form_name);
            formData.append('description', this.form_description);

            $.ajax({
                type: 'POST',
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/create_form/`,
                data: formData,
                processData: false,
                contentType: false,
                headers: {
                    'Authorization': `Token ${this.getToken()}`,
                },
                success: (response) => {
                    if (response.status === "success") {
                        Swal.fire({
                            icon: "success",
                            title: "Form created",
                            showConfirmButton: false,
                            timer: 1000
                        }).then(() => {
                            this.forms.unshift(response.data);
                            $('#create_form').modal('hide');
                        });
                    }
                },
                error: (response) => {
                    Swal.close();
                    const response_data = response.responseJSON;
                    if (response_data) {
                        this.errors = response_data;
                    }
                },
                complete: () => {
                    this.isSubmitting = false;
                },
            });
        },

        fetch_forms() {
            this.token_exists = get_token();

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_forms/`,
                method: "POST",
                headers: this.token_exists
                    ? {
                        Authorization: `Token ${this.getToken()}`,
                        "Content-Type": "application/json",
                    }
                    : {},
                success: (response) => {
                    this.forms = response.data.forms;

                    this.$nextTick(() => {
                        $('.table').DataTable().destroy();
                        $('.table').DataTable({
                            paging: true,
                            searching: true,
                            ordering: true,
                            info: true,
                            lengthChange: true,
                            pageLength: 10,
                            language: {
                                paginate: {
                                    previous: "Previous",
                                    next: "Next"
                                },
                                info: "Showing _START_ to _END_ of _TOTAL_ entries",
                                infoEmpty: "No entries available"
                            }
                        });
                    });
                },
                complete: () => {
                    this.isLoading = false;
                },
            });
        },

        validateForm() {
            this.errors = {};
            let isValid = true;
            if (!this.form_name.trim()) {
                this.errors.form_name = 'Form name is required.';
                isValid = false;
            }

            return isValid;
        },

        getProfileTypes() {
              this.token_exists = get_token();
              $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_profile_types/`, // Replace with the correct endpoint
                method: "GET",
                headers: { Authorization: `Token ${this.getToken()}` },
                success: (response) => {
                  this.profile_types = response.data;
                },
                error: () => {
                  Swal.fire({
                    icon: "error",
                    title: "Failed to Load Profile Types",
                    text: "An error occurred while fetching profile types. Please try again.",
                  });
                },
              });
            },

        resetForm() {
            this.form_name = '';
            this.form_description = '';
            this.errors = {};
        },

        assignQuestions() {
            if (this.selected_profiles .length === 0) {
                Swal.fire({
                    icon: "error",
                    title: "No Profile Selected",
                    text: "Please select at least one profile type to assign the questions.",
                });
                return;
            }
            const assignmentData = {
                form_id: this.form_id,
                profile_type_ids: this.selected_profiles,
                business_tab:this.selected_business_tab || ''
            };
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/assign_profile_question/`,
                method: "POST",
                headers: { Authorization: `Token ${this.getToken()}` },
                data: JSON.stringify(assignmentData),
                contentType: "application/json",
                success: (response) => {
                    if (response.status == "success") {
                        Swal.fire({
                            icon: "success",
                            title: "Questions Assigned",
                            text: "The selected questions have been successfully assigned to the selected profiles.",
                            showConfirmButton: false,
                            timer: 2000
                        });
                    }
                    this.selected_form_sections = [];
                    this.selected_profiles  = [];
                    this.allSelected = false;
                    $("#assignQuestionsModal").modal('hide')

                },
                error: () => {
                    Swal.fire({
                        icon: "error",
                        title: "Assignment Failed",
                        text: "An error occurred while assigning the questions. Please try again.",
                    });
                },
            });
        },

        prepareAssignQuestions(form) {
            this.form_id=form.id
            this.selected_form_sections = [];
            this.selected_profiles  = [];

             this.selected_profiles = this.profile_types
    .filter(p => form.assigned_profile_types.includes(p.name))
    .map(p => p.id);

        },

        delete_form(form_id) {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    $.ajax({
                        type: 'DELETE',
                        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/delete_form/`,
                        data: JSON.stringify({ form_id }),
                        contentType: 'application/json',
                        headers: {
                            'Authorization': `Token ${this.getToken()}`,
                        },
                        success: (response) => {
                            if (response.status === "success") {
                                Swal.fire(
                                    'Deleted!',
                                    'Your form has been deleted.',
                                    'success'
                                );
                                this.forms = this.forms.filter(form => form.id !== form_id);
                            }
                        },
                        error: () => {
                            Swal.fire({
                                icon: "error",
                                title: "Deletion Failed",
                                text: "An error occurred while deleting the form. Please try again.",
                            });
                        }
                    });
                }
            });
        }

    }
}
